import { http } from "@/lib/http";

/**
 * Preferencia pessoal, guardada no servidor e nao no navegador.
 *
 * `localStorage` seria mais barato e estaria errado: a mesma pessoa abre o
 * painel do celular no chao de fabrica e do desktop na sala, e uma escolha que
 * nao viaja entre os dois nao e preferencia — e configuracao de maquina.
 */
export async function lerPreferencia<T>(
  chave: string,
  signal?: AbortSignal,
): Promise<T | null> {
  const resposta = await http.get<{ valor: T | null }>(
    `/api/preferences/${encodeURIComponent(chave)}`,
    { signal },
  );
  return resposta.valor;
}

/** `valor: null` apaga a preferencia e devolve a pessoa ao padrao do painel. */
export async function salvarPreferencia(chave: string, valor: unknown): Promise<void> {
  await http.put<{ ok: boolean }>(`/api/preferences/${encodeURIComponent(chave)}`, {
    valor,
  });
}
